import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';

interface IPageCp2016 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Cp2016Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    $stateParams: any ) {
    const vm: IPageCp2016 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
            boutonDupliquer: false
        },
        colonnesVisibles: [
            { nom: 'fhrdatsus', largeur: 120 },
            { nom: 'fhrcom', largeur: 250 },
            { nom: 'datcre', largeur: 126 },
            { nom: 'fhrindact', largeur: 120 },
            { nom: 'fhrindman', largeur: 120 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('foucleint', { default: $stateParams.foucleint }),
            new FormulaireItem('fhrdatsus'),
            new FormulaireItem('fhrcom', { enableCount: true }),
            new FormulaireItem('fhrindact', { default: 1 }),
            new FormulaireItem('fhrindman'),
        ])
    };
}
